import { Direction, Slide, IconButton } from '@patrianna/core-components'
import cx from 'classnames'
import type { ReactNode } from 'react'

import classes from './styles.module.scss'

type Props = {
  children: ReactNode
  closeHandler: () => void
  withButton?: boolean
  handleClick?: () => void
}
export default function MessageLayout(props: Props) {
  return (
    <Slide direction={Direction.Up} in className={classes.slide}>
      <div className={cx(classes.root, props.withButton && classes['with-button'])}>
        <div onClick={props.handleClick} className={classes.body} role='button'>
          <img
            className={classes.logo}
            width='64'
            height='64'
            src={`${process.env.IMG_ORIGIN}/pwa_icon_${process.env.BRAND_NAME}.png`}
            alt='pwa icon'
          />

          <div className={classes.content}>{props.children}</div>
        </div>

        <IconButton onClick={props.closeHandler} className={classes.close}>
          <span className={classes['close-icon']} />
        </IconButton>
      </div>
    </Slide>
  )
}
